export function IconWallet() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path
        fill="#9895a6"
        d="M19.986 26a2.989 2.989 0 01-2.975-3v-3.059a2.989 2.989 0 012.975-3h3.039a2.988 2.988 0 012.974 3V23a2.988 2.988 0 01-2.974 3zm-1.58-6.059V23a1.593 1.593 0 001.58 1.6h3.039A1.592 1.592 0 0024.6 23v-3.059a1.592 1.592 0 00-1.58-1.6h-3.034a1.593 1.593 0 00-1.58 1.6zM8.975 26A2.989 2.989 0 016 23v-3.059a2.989 2.989 0 012.975-3h3.039a2.989 2.989 0 012.975 3V23a2.989 2.989 0 01-2.975 3zm-1.58-6.059V23a1.593 1.593 0 001.58 1.6h3.039a1.593 1.593 0 001.58-1.6v-3.059a1.593 1.593 0 00-1.58-1.6H8.975a1.593 1.593 0 00-1.58 1.6zm12.591-4.886a2.989 2.989 0 01-2.975-3V9a2.989 2.989 0 012.975-3h3.039A2.988 2.988 0 0126 9v3.06a2.988 2.988 0 01-2.974 3zM18.406 9v3.06a1.593 1.593 0 001.58 1.6h3.039a1.592 1.592 0 001.58-1.6V9a1.592 1.592 0 00-1.58-1.6h-3.039a1.593 1.593 0 00-1.58 1.6zm-9.43 6.06a2.989 2.989 0 01-2.976-3V9a2.989 2.989 0 012.975-3h3.039a2.989 2.989 0 012.975 3v3.06a2.989 2.989 0 01-2.975 3zM7.395 9v3.06a1.593 1.593 0 001.58 1.6h3.039a1.593 1.593 0 001.58-1.6V9a1.593 1.593 0 00-1.58-1.6H8.975A1.593 1.593 0 007.395 9z"
      />
    </svg>
  );
}

export function IconBonding() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path
        fill="#9895a6"
        d="M11.454 26A5.242 5.242 0 016 20.549v-8.042c0-3.276 2.075-5.584 5.227-5.69H18.5a.725.725 0 01.1 1.443l-.1.006h-7.046a3.824 3.824 0 00-4 4.019v8.033c0 2.514 1.437 4.138 3.784 4.231h8.554a3.817 3.817 0 004-4.011v-7.024a.727.727 0 011.446-.1l.007.1v6.8c0 3.275-2.074 5.575-5.228 5.681h-.227zm-.754-6.564l-.09-.058a.724.724 0 01-.192-.927l.059-.089 2.902-3.762a.729.729 0 01.935-.188l.09.06 2.732 2.14 2.392-3.072a.726.726 0 011.209.8l-.06.089-2.838 3.651a.729.729 0 01-.934.186l-.089-.06-2.732-2.139-2.453 3.177a.729.729 0 01-.93.192zM20.821 8.581a2.589 2.589 0 112.589 2.581 2.589 2.589 0 01-2.589-2.581zm1.453 0a1.136 1.136 0 101.136-1.132 1.135 1.135 0 00-1.135 1.132z"
      />
    </svg>
  );
}

export function IconExchange() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path
        fill="#9895a6"
        d="M11.641 26a5.478 5.478 0 01-4.092-1.642A6.024 6.024 0 016 20.107v-8.214a6.018 6.018 0 011.552-4.249A5.475 5.475 0 0111.641 6h8.717a5.478 5.478 0 014.092 1.643 6.024 6.024 0 011.55 4.25v8.213a6.024 6.024 0 01-1.549 4.251A5.478 5.478 0 0120.359 26zM7.395 11.893v8.213c0 2.732 1.667 4.5 4.246 4.5h8.717c2.579 0 4.246-1.766 4.246-4.5v-8.213c0-2.732-1.667-4.5-4.246-4.5h-8.717c-2.579.002-4.246 1.768-4.246 4.5zM19.614 20.8l-.006-.095V17.7A.7.7 0 0121 17.6v3.11a.7.7 0 01-1.389.095zm-4.271 0l-.006-.095v-9.431a.7.7 0 011.39-.1l.006.1v9.435a.7.7 0 01-1.39.095zM11 20.8v-6.473a.7.7 0 011.389-.095l.006.095v6.382A.7.7 0 0111 20.8z"
      />
    </svg>
  );
}

export function IconDefault() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path
        fill="#9895a6"
        d="M11.665 26a5.5 5.5 0 01-4.109-1.651A6.043 6.043 0 016 20.084v-8.168a6.044 6.044 0 011.558-4.265A5.5 5.5 0 0111.665 6h8.67a5.5 5.5 0 014.109 1.651A6.043 6.043 0 0126 11.916v8.168a6.042 6.042 0 01-1.557 4.265A5.5 5.5 0 0120.333 26zM7.5 11.916v8.168c0 2.683 1.634 4.416 4.164 4.416h8.669c2.532 0 4.167-1.733 4.167-4.416v-8.168A4.579 4.579 0 0023.374 8.7a4.04 4.04 0 00-3.039-1.2h-8.67C9.135 7.5 7.5 9.234 7.5 11.916zm7.746 7.984l-.006-.1v-4.423a.75.75 0 011.493-.1l.007.1V19.8a.751.751 0 01-1.494.1zm-.007-7.7a.75.75 0 01.648-.742l.113-.004a.75.75 0 01.1 1.493l-.112.007a.75.75 0 01-.749-.754z"
      />
    </svg>
  );
}

export function IconCaret() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
      <path
        fill="#e1dfeb"
        d="M7.7 9.759l.044.05 3.882 3.806a.451.451 0 00.63 0 .431.431 0 00.043-.572l-.043-.049-3.568-3.5 3.568-3.5a.431.431 0 00.043-.568l-.043-.049a.453.453 0 00-.58-.042l-.05.042-3.882 3.814a.43.43 0 00-.044.568z"
      />
    </svg>
  );
}

export function IconBridge() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="#9895a6"
        d="M3.804 11.556l.073-.084 4.067-4.043a.743.743 0 011.121.971l-.072.084-3.533 3.515 3.533 3.518a.744.744 0 01-.965 1.126l-.084-.071-4.067-4.045a.745.745 0 01-.073-.971zm11.134-4.044l.071-.081a.746.746 0 01.969-.074l.082.072 4.064 4.044a.743.743 0 01.073.97l-.073.084-4.063 4.045a.744.744 0 01-1.117-.972l.072-.082 3.528-3.519-3.532-3.517a.743.743 0 01-.074-.97z"
      />
    </svg>
  );
}
